import React from 'react';
import CoverWithAnalysis from './CoverWithAnalysis';
import Button from '@/components/input/Button';
import { generatePath, useNavigate } from 'react-router';
import { routes } from '@/constants/routes';
import SimpleCover from './SimpleCover';

interface Props {
  emoji?: string;
  title: string;
  benefits?: string[];
  analysis?: string;
  routeId?: string;
  shouldGenerateAnalysis?: boolean;
  contentInteractionId?: string;
}

const CompleteContentCover: React.FC<Props> = ({
  emoji,
  title,
  benefits,
  routeId,
  contentInteractionId,
  shouldGenerateAnalysis,
  analysis,
}) => {
  const navigate = useNavigate();
  const handleRedirectToRoute = () => {
    navigate(generatePath(routes.routes.detail, { routeId }));
  };

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', gap: 16, flex: 1, padding: 16, overflow: 'hidden' }}
    >
      {shouldGenerateAnalysis || analysis ? (
        <CoverWithAnalysis
          emoji={emoji}
          title={title}
          analysis={analysis}
          contentInteractionId={contentInteractionId}
          shouldGenerateAnalysis={shouldGenerateAnalysis}
        />
      ) : (
        <SimpleCover title={title} emoji={emoji} benefits={benefits} />
      )}
      <Button variant="main" onClick={handleRedirectToRoute}>
        Continuar Aprendiendo
      </Button>
    </div>
  );
};

export default CompleteContentCover;
